/* eslint-disable */
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var rpc_admin_suppliers_pb = require('../../rpc/admin/suppliers_pb.js');
goog.object.extend(proto, rpc_admin_suppliers_pb);
var gogoproto_gogo_pb = require('../../gogoproto/gogo_pb.js');
goog.object.extend(proto, gogoproto_gogo_pb);
goog.exportSymbol('proto.admin.AutocompleteRequest', null, global);
goog.exportSymbol('proto.admin.AutocompleteResponse', null, global);
goog.exportSymbol('proto.admin.Hit', null, global);
goog.exportSymbol('proto.admin.SearchRequest', null, global);
goog.exportSymbol('proto.admin.SearchRequest.Direction', null, global);
goog.exportSymbol('proto.admin.SearchRequest.Filter', null, global);
goog.exportSymbol('proto.admin.SearchRequest.Filter.Range', null, global);
goog.exportSymbol('proto.admin.SearchRequest.Filter.String', null, global);
goog.exportSymbol('proto.admin.SearchResponse', null, global);
goog.exportSymbol('proto.admin.SearchResponse.Aggregation', null, global);
goog.exportSymbol('proto.admin.SearchResponse.Aggregation.Range', null, global);
goog.exportSymbol('proto.admin.SearchResponse.Aggregation.String', null, global);
goog.exportSymbol('proto.admin.SearchResponse.Aggregation.Value', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admin.SearchRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.admin.SearchRequest.repeatedFields_, null);
};
goog.inherits(proto.admin.SearchRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admin.SearchRequest.displayName = 'proto.admin.SearchRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admin.SearchRequest.Filter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.admin.SearchRequest.Filter.oneofGroups_);
};
goog.inherits(proto.admin.SearchRequest.Filter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admin.SearchRequest.Filter.displayName = 'proto.admin.SearchRequest.Filter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admin.SearchRequest.Filter.String = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.admin.SearchRequest.Filter.String, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admin.SearchRequest.Filter.String.displayName = 'proto.admin.SearchRequest.Filter.String';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admin.SearchRequest.Filter.Range = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.admin.SearchRequest.Filter.Range, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admin.SearchRequest.Filter.Range.displayName = 'proto.admin.SearchRequest.Filter.Range';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admin.Hit = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.admin.Hit, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admin.Hit.displayName = 'proto.admin.Hit';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admin.SearchResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.admin.SearchResponse.repeatedFields_, null);
};
goog.inherits(proto.admin.SearchResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admin.SearchResponse.displayName = 'proto.admin.SearchResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admin.SearchResponse.Aggregation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.admin.SearchResponse.Aggregation.repeatedFields_, null);
};
goog.inherits(proto.admin.SearchResponse.Aggregation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admin.SearchResponse.Aggregation.displayName = 'proto.admin.SearchResponse.Aggregation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admin.SearchResponse.Aggregation.String = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.admin.SearchResponse.Aggregation.String, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admin.SearchResponse.Aggregation.String.displayName = 'proto.admin.SearchResponse.Aggregation.String';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admin.SearchResponse.Aggregation.Range = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.admin.SearchResponse.Aggregation.Range, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admin.SearchResponse.Aggregation.Range.displayName = 'proto.admin.SearchResponse.Aggregation.Range';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admin.SearchResponse.Aggregation.Value = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.admin.SearchResponse.Aggregation.Value.oneofGroups_);
};
goog.inherits(proto.admin.SearchResponse.Aggregation.Value, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admin.SearchResponse.Aggregation.Value.displayName = 'proto.admin.SearchResponse.Aggregation.Value';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admin.AutocompleteRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.admin.AutocompleteRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admin.AutocompleteRequest.displayName = 'proto.admin.AutocompleteRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admin.AutocompleteResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.admin.AutocompleteResponse.repeatedFields_, null);
};
goog.inherits(proto.admin.AutocompleteResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admin.AutocompleteResponse.displayName = 'proto.admin.AutocompleteResponse';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.admin.SearchRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admin.SearchRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.admin.SearchRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admin.SearchRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.SearchRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    query: jspb.Message.getFieldWithDefault(msg, 1, ""),
    filtersList: jspb.Message.toObjectList(msg.getFiltersList(),
    proto.admin.SearchRequest.Filter.toObject, includeInstance),
    sortField: jspb.Message.getFieldWithDefault(msg, 3, ""),
    sortOrder: jspb.Message.getFieldWithDefault(msg, 4, 0),
    offset: jspb.Message.getFieldWithDefault(msg, 5, 0),
    limit: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admin.SearchRequest}
 */
proto.admin.SearchRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admin.SearchRequest;
  return proto.admin.SearchRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admin.SearchRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admin.SearchRequest}
 */
proto.admin.SearchRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuery(value);
      break;
    case 2:
      var value = new proto.admin.SearchRequest.Filter;
      reader.readMessage(value,proto.admin.SearchRequest.Filter.deserializeBinaryFromReader);
      msg.addFilters(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSortField(value);
      break;
    case 4:
      var value = /** @type {!proto.admin.SearchRequest.Direction} */ (reader.readEnum());
      msg.setSortOrder(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOffset(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admin.SearchRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admin.SearchRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admin.SearchRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.SearchRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuery();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFiltersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.admin.SearchRequest.Filter.serializeBinaryToWriter
    );
  }
  f = message.getSortField();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSortOrder();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getOffset();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.admin.SearchRequest.Direction = {
  DIRECTION_UNKNOWN: 0,
  DIRECTION_ASCENDING: 1,
  DIRECTION_DESCENDING: 2
};


/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.admin.SearchRequest.Filter.oneofGroups_ = [[2,3]];

/**
 * @enum {number}
 */
proto.admin.SearchRequest.Filter.ValueCase = {
  VALUE_NOT_SET: 0,
  STRING_FILTER: 2,
  RANGE_FILTER: 3
};

/**
 * @return {proto.admin.SearchRequest.Filter.ValueCase}
 */
proto.admin.SearchRequest.Filter.prototype.getValueCase = function() {
  return /** @type {proto.admin.SearchRequest.Filter.ValueCase} */(jspb.Message.computeOneofCase(this, proto.admin.SearchRequest.Filter.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admin.SearchRequest.Filter.prototype.toObject = function(opt_includeInstance) {
  return proto.admin.SearchRequest.Filter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admin.SearchRequest.Filter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.SearchRequest.Filter.toObject = function(includeInstance, msg) {
  var f, obj = {
    field: jspb.Message.getFieldWithDefault(msg, 1, ""),
    stringFilter: (f = msg.getStringFilter()) && proto.admin.SearchRequest.Filter.String.toObject(includeInstance, f),
    rangeFilter: (f = msg.getRangeFilter()) && proto.admin.SearchRequest.Filter.Range.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admin.SearchRequest.Filter}
 */
proto.admin.SearchRequest.Filter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admin.SearchRequest.Filter;
  return proto.admin.SearchRequest.Filter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admin.SearchRequest.Filter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admin.SearchRequest.Filter}
 */
proto.admin.SearchRequest.Filter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setField(value);
      break;
    case 2:
      var value = new proto.admin.SearchRequest.Filter.String;
      reader.readMessage(value,proto.admin.SearchRequest.Filter.String.deserializeBinaryFromReader);
      msg.setStringFilter(value);
      break;
    case 3:
      var value = new proto.admin.SearchRequest.Filter.Range;
      reader.readMessage(value,proto.admin.SearchRequest.Filter.Range.deserializeBinaryFromReader);
      msg.setRangeFilter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admin.SearchRequest.Filter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admin.SearchRequest.Filter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admin.SearchRequest.Filter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.SearchRequest.Filter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getField();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStringFilter();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.admin.SearchRequest.Filter.String.serializeBinaryToWriter
    );
  }
  f = message.getRangeFilter();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.admin.SearchRequest.Filter.Range.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admin.SearchRequest.Filter.String.prototype.toObject = function(opt_includeInstance) {
  return proto.admin.SearchRequest.Filter.String.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admin.SearchRequest.Filter.String} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.SearchRequest.Filter.String.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admin.SearchRequest.Filter.String}
 */
proto.admin.SearchRequest.Filter.String.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admin.SearchRequest.Filter.String;
  return proto.admin.SearchRequest.Filter.String.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admin.SearchRequest.Filter.String} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admin.SearchRequest.Filter.String}
 */
proto.admin.SearchRequest.Filter.String.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admin.SearchRequest.Filter.String.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admin.SearchRequest.Filter.String.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admin.SearchRequest.Filter.String} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.SearchRequest.Filter.String.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string value = 1;
 * @return {string}
 */
proto.admin.SearchRequest.Filter.String.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.admin.SearchRequest.Filter.String.prototype.setValue = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admin.SearchRequest.Filter.Range.prototype.toObject = function(opt_includeInstance) {
  return proto.admin.SearchRequest.Filter.Range.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admin.SearchRequest.Filter.Range} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.SearchRequest.Filter.Range.toObject = function(includeInstance, msg) {
  var f, obj = {
    from: +jspb.Message.getFieldWithDefault(msg, 1, 0.0),
    to: +jspb.Message.getFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admin.SearchRequest.Filter.Range}
 */
proto.admin.SearchRequest.Filter.Range.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admin.SearchRequest.Filter.Range;
  return proto.admin.SearchRequest.Filter.Range.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admin.SearchRequest.Filter.Range} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admin.SearchRequest.Filter.Range}
 */
proto.admin.SearchRequest.Filter.Range.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setFrom(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admin.SearchRequest.Filter.Range.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admin.SearchRequest.Filter.Range.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admin.SearchRequest.Filter.Range} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.SearchRequest.Filter.Range.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFrom();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getTo();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
};


/**
 * optional double from = 1;
 * @return {number}
 */
proto.admin.SearchRequest.Filter.Range.prototype.getFrom = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 1, 0.0));
};


/** @param {number} value */
proto.admin.SearchRequest.Filter.Range.prototype.setFrom = function(value) {
  jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double to = 2;
 * @return {number}
 */
proto.admin.SearchRequest.Filter.Range.prototype.getTo = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 2, 0.0));
};


/** @param {number} value */
proto.admin.SearchRequest.Filter.Range.prototype.setTo = function(value) {
  jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional string field = 1;
 * @return {string}
 */
proto.admin.SearchRequest.Filter.prototype.getField = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.admin.SearchRequest.Filter.prototype.setField = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional String string_filter = 2;
 * @return {?proto.admin.SearchRequest.Filter.String}
 */
proto.admin.SearchRequest.Filter.prototype.getStringFilter = function() {
  return /** @type{?proto.admin.SearchRequest.Filter.String} */ (
    jspb.Message.getWrapperField(this, proto.admin.SearchRequest.Filter.String, 2));
};


/** @param {?proto.admin.SearchRequest.Filter.String|undefined} value */
proto.admin.SearchRequest.Filter.prototype.setStringFilter = function(value) {
  jspb.Message.setOneofWrapperField(this, 2, proto.admin.SearchRequest.Filter.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 */
proto.admin.SearchRequest.Filter.prototype.clearStringFilter = function() {
  this.setStringFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.admin.SearchRequest.Filter.prototype.hasStringFilter = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Range range_filter = 3;
 * @return {?proto.admin.SearchRequest.Filter.Range}
 */
proto.admin.SearchRequest.Filter.prototype.getRangeFilter = function() {
  return /** @type{?proto.admin.SearchRequest.Filter.Range} */ (
    jspb.Message.getWrapperField(this, proto.admin.SearchRequest.Filter.Range, 3));
};


/** @param {?proto.admin.SearchRequest.Filter.Range|undefined} value */
proto.admin.SearchRequest.Filter.prototype.setRangeFilter = function(value) {
  jspb.Message.setOneofWrapperField(this, 3, proto.admin.SearchRequest.Filter.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 */
proto.admin.SearchRequest.Filter.prototype.clearRangeFilter = function() {
  this.setRangeFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.admin.SearchRequest.Filter.prototype.hasRangeFilter = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string query = 1;
 * @return {string}
 */
proto.admin.SearchRequest.prototype.getQuery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.admin.SearchRequest.prototype.setQuery = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated Filter filters = 2;
 * @return {!Array<!proto.admin.SearchRequest.Filter>}
 */
proto.admin.SearchRequest.prototype.getFiltersList = function() {
  return /** @type{!Array<!proto.admin.SearchRequest.Filter>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.admin.SearchRequest.Filter, 2));
};


/** @param {!Array<!proto.admin.SearchRequest.Filter>} value */
proto.admin.SearchRequest.prototype.setFiltersList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.admin.SearchRequest.Filter=} opt_value
 * @param {number=} opt_index
 * @return {!proto.admin.SearchRequest.Filter}
 */
proto.admin.SearchRequest.prototype.addFilters = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.admin.SearchRequest.Filter, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.admin.SearchRequest.prototype.clearFiltersList = function() {
  this.setFiltersList([]);
};


/**
 * optional string sort_field = 3;
 * @return {string}
 */
proto.admin.SearchRequest.prototype.getSortField = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.admin.SearchRequest.prototype.setSortField = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional Direction sort_order = 4;
 * @return {!proto.admin.SearchRequest.Direction}
 */
proto.admin.SearchRequest.prototype.getSortOrder = function() {
  return /** @type {!proto.admin.SearchRequest.Direction} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {!proto.admin.SearchRequest.Direction} value */
proto.admin.SearchRequest.prototype.setSortOrder = function(value) {
  jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional int32 offset = 5;
 * @return {number}
 */
proto.admin.SearchRequest.prototype.getOffset = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.admin.SearchRequest.prototype.setOffset = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 limit = 6;
 * @return {number}
 */
proto.admin.SearchRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.admin.SearchRequest.prototype.setLimit = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admin.Hit.prototype.toObject = function(opt_includeInstance) {
  return proto.admin.Hit.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admin.Hit} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.Hit.toObject = function(includeInstance, msg) {
  var f, obj = {
    sku: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    manufacturer: jspb.Message.getFieldWithDefault(msg, 3, ""),
    category: jspb.Message.getFieldWithDefault(msg, 4, ""),
    snippet: jspb.Message.getFieldWithDefault(msg, 5, ""),
    price: jspb.Message.getFieldWithDefault(msg, 6, 0),
    mapp: jspb.Message.getFieldWithDefault(msg, 7, 0),
    msrp: jspb.Message.getFieldWithDefault(msg, 8, 0),
    qoh: jspb.Message.getFieldWithDefault(msg, 9, 0),
    url: jspb.Message.getFieldWithDefault(msg, 10, ""),
    thumbnail: jspb.Message.getFieldWithDefault(msg, 11, ""),
    supplier: jspb.Message.getFieldWithDefault(msg, 12, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admin.Hit}
 */
proto.admin.Hit.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admin.Hit;
  return proto.admin.Hit.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admin.Hit} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admin.Hit}
 */
proto.admin.Hit.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSku(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setManufacturer(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCategory(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSnippet(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPrice(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMapp(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMsrp(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQoh(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setThumbnail(value);
      break;
    case 12:
      var value = /** @type {!proto.admin.Supplier} */ (reader.readEnum());
      msg.setSupplier(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admin.Hit.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admin.Hit.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admin.Hit} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.Hit.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSku();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getManufacturer();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCategory();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSnippet();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPrice();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getMapp();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getMsrp();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getQoh();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getThumbnail();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getSupplier();
  if (f !== 0.0) {
    writer.writeEnum(
      12,
      f
    );
  }
};


/**
 * optional string sku = 1;
 * @return {string}
 */
proto.admin.Hit.prototype.getSku = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.admin.Hit.prototype.setSku = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.admin.Hit.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.admin.Hit.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string manufacturer = 3;
 * @return {string}
 */
proto.admin.Hit.prototype.getManufacturer = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.admin.Hit.prototype.setManufacturer = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string category = 4;
 * @return {string}
 */
proto.admin.Hit.prototype.getCategory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.admin.Hit.prototype.setCategory = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string snippet = 5;
 * @return {string}
 */
proto.admin.Hit.prototype.getSnippet = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.admin.Hit.prototype.setSnippet = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int32 price = 6;
 * @return {number}
 */
proto.admin.Hit.prototype.getPrice = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.admin.Hit.prototype.setPrice = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 mapp = 7;
 * @return {number}
 */
proto.admin.Hit.prototype.getMapp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.admin.Hit.prototype.setMapp = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int32 msrp = 8;
 * @return {number}
 */
proto.admin.Hit.prototype.getMsrp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {number} value */
proto.admin.Hit.prototype.setMsrp = function(value) {
  jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int32 qoh = 9;
 * @return {number}
 */
proto.admin.Hit.prototype.getQoh = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {number} value */
proto.admin.Hit.prototype.setQoh = function(value) {
  jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional string url = 10;
 * @return {string}
 */
proto.admin.Hit.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/** @param {string} value */
proto.admin.Hit.prototype.setUrl = function(value) {
  jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string thumbnail = 11;
 * @return {string}
 */
proto.admin.Hit.prototype.getThumbnail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/** @param {string} value */
proto.admin.Hit.prototype.setThumbnail = function(value) {
  jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional Supplier supplier = 12;
 * @return {!proto.admin.Supplier}
 */
proto.admin.Hit.prototype.getSupplier = function() {
  return /** @type {!proto.admin.Supplier} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/** @param {!proto.admin.Supplier} value */
proto.admin.Hit.prototype.setSupplier = function(value) {
  jspb.Message.setProto3EnumField(this, 12, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.admin.SearchResponse.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admin.SearchResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.admin.SearchResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admin.SearchResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.SearchResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    hitsList: jspb.Message.toObjectList(msg.getHitsList(),
    proto.admin.Hit.toObject, includeInstance),
    aggregationsList: jspb.Message.toObjectList(msg.getAggregationsList(),
    proto.admin.SearchResponse.Aggregation.toObject, includeInstance),
    total: jspb.Message.getFieldWithDefault(msg, 3, 0),
    didYouMean: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admin.SearchResponse}
 */
proto.admin.SearchResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admin.SearchResponse;
  return proto.admin.SearchResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admin.SearchResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admin.SearchResponse}
 */
proto.admin.SearchResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.admin.Hit;
      reader.readMessage(value,proto.admin.Hit.deserializeBinaryFromReader);
      msg.addHits(value);
      break;
    case 2:
      var value = new proto.admin.SearchResponse.Aggregation;
      reader.readMessage(value,proto.admin.SearchResponse.Aggregation.deserializeBinaryFromReader);
      msg.addAggregations(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotal(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDidYouMean(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admin.SearchResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admin.SearchResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admin.SearchResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.SearchResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHitsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.admin.Hit.serializeBinaryToWriter
    );
  }
  f = message.getAggregationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.admin.SearchResponse.Aggregation.serializeBinaryToWriter
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getDidYouMean();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.admin.SearchResponse.Aggregation.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admin.SearchResponse.Aggregation.prototype.toObject = function(opt_includeInstance) {
  return proto.admin.SearchResponse.Aggregation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admin.SearchResponse.Aggregation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.SearchResponse.Aggregation.toObject = function(includeInstance, msg) {
  var f, obj = {
    field: jspb.Message.getFieldWithDefault(msg, 1, ""),
    label: jspb.Message.getFieldWithDefault(msg, 2, ""),
    aggregationsList: jspb.Message.toObjectList(msg.getAggregationsList(),
    proto.admin.SearchResponse.Aggregation.Value.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admin.SearchResponse.Aggregation}
 */
proto.admin.SearchResponse.Aggregation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admin.SearchResponse.Aggregation;
  return proto.admin.SearchResponse.Aggregation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admin.SearchResponse.Aggregation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admin.SearchResponse.Aggregation}
 */
proto.admin.SearchResponse.Aggregation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setField(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 3:
      var value = new proto.admin.SearchResponse.Aggregation.Value;
      reader.readMessage(value,proto.admin.SearchResponse.Aggregation.Value.deserializeBinaryFromReader);
      msg.addAggregations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admin.SearchResponse.Aggregation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admin.SearchResponse.Aggregation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admin.SearchResponse.Aggregation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.SearchResponse.Aggregation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getField();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAggregationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.admin.SearchResponse.Aggregation.Value.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admin.SearchResponse.Aggregation.String.prototype.toObject = function(opt_includeInstance) {
  return proto.admin.SearchResponse.Aggregation.String.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admin.SearchResponse.Aggregation.String} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.SearchResponse.Aggregation.String.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, ""),
    label: jspb.Message.getFieldWithDefault(msg, 2, ""),
    count: jspb.Message.getFieldWithDefault(msg, 3, 0),
    checked: jspb.Message.getFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admin.SearchResponse.Aggregation.String}
 */
proto.admin.SearchResponse.Aggregation.String.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admin.SearchResponse.Aggregation.String;
  return proto.admin.SearchResponse.Aggregation.String.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admin.SearchResponse.Aggregation.String} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admin.SearchResponse.Aggregation.String}
 */
proto.admin.SearchResponse.Aggregation.String.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCount(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setChecked(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admin.SearchResponse.Aggregation.String.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admin.SearchResponse.Aggregation.String.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admin.SearchResponse.Aggregation.String} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.SearchResponse.Aggregation.String.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCount();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getChecked();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional string value = 1;
 * @return {string}
 */
proto.admin.SearchResponse.Aggregation.String.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.admin.SearchResponse.Aggregation.String.prototype.setValue = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string label = 2;
 * @return {string}
 */
proto.admin.SearchResponse.Aggregation.String.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.admin.SearchResponse.Aggregation.String.prototype.setLabel = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 count = 3;
 * @return {number}
 */
proto.admin.SearchResponse.Aggregation.String.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.admin.SearchResponse.Aggregation.String.prototype.setCount = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional bool checked = 4;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.admin.SearchResponse.Aggregation.String.prototype.getChecked = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 4, false));
};


/** @param {boolean} value */
proto.admin.SearchResponse.Aggregation.String.prototype.setChecked = function(value) {
  jspb.Message.setProto3BooleanField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admin.SearchResponse.Aggregation.Range.prototype.toObject = function(opt_includeInstance) {
  return proto.admin.SearchResponse.Aggregation.Range.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admin.SearchResponse.Aggregation.Range} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.SearchResponse.Aggregation.Range.toObject = function(includeInstance, msg) {
  var f, obj = {
    from: +jspb.Message.getFieldWithDefault(msg, 1, 0.0),
    to: +jspb.Message.getFieldWithDefault(msg, 2, 0.0),
    label: jspb.Message.getFieldWithDefault(msg, 3, ""),
    count: jspb.Message.getFieldWithDefault(msg, 4, 0),
    checked: jspb.Message.getFieldWithDefault(msg, 5, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admin.SearchResponse.Aggregation.Range}
 */
proto.admin.SearchResponse.Aggregation.Range.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admin.SearchResponse.Aggregation.Range;
  return proto.admin.SearchResponse.Aggregation.Range.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admin.SearchResponse.Aggregation.Range} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admin.SearchResponse.Aggregation.Range}
 */
proto.admin.SearchResponse.Aggregation.Range.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setFrom(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTo(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCount(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setChecked(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admin.SearchResponse.Aggregation.Range.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admin.SearchResponse.Aggregation.Range.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admin.SearchResponse.Aggregation.Range} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.SearchResponse.Aggregation.Range.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFrom();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getTo();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCount();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getChecked();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
};


/**
 * optional double from = 1;
 * @return {number}
 */
proto.admin.SearchResponse.Aggregation.Range.prototype.getFrom = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 1, 0.0));
};


/** @param {number} value */
proto.admin.SearchResponse.Aggregation.Range.prototype.setFrom = function(value) {
  jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double to = 2;
 * @return {number}
 */
proto.admin.SearchResponse.Aggregation.Range.prototype.getTo = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 2, 0.0));
};


/** @param {number} value */
proto.admin.SearchResponse.Aggregation.Range.prototype.setTo = function(value) {
  jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional string label = 3;
 * @return {string}
 */
proto.admin.SearchResponse.Aggregation.Range.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.admin.SearchResponse.Aggregation.Range.prototype.setLabel = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 count = 4;
 * @return {number}
 */
proto.admin.SearchResponse.Aggregation.Range.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.admin.SearchResponse.Aggregation.Range.prototype.setCount = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional bool checked = 5;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.admin.SearchResponse.Aggregation.Range.prototype.getChecked = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 5, false));
};


/** @param {boolean} value */
proto.admin.SearchResponse.Aggregation.Range.prototype.setChecked = function(value) {
  jspb.Message.setProto3BooleanField(this, 5, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.admin.SearchResponse.Aggregation.Value.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.admin.SearchResponse.Aggregation.Value.ValueCase = {
  VALUE_NOT_SET: 0,
  STRING_AGGREGATION: 1,
  RANGE_AGGREGATION: 2
};

/**
 * @return {proto.admin.SearchResponse.Aggregation.Value.ValueCase}
 */
proto.admin.SearchResponse.Aggregation.Value.prototype.getValueCase = function() {
  return /** @type {proto.admin.SearchResponse.Aggregation.Value.ValueCase} */(jspb.Message.computeOneofCase(this, proto.admin.SearchResponse.Aggregation.Value.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admin.SearchResponse.Aggregation.Value.prototype.toObject = function(opt_includeInstance) {
  return proto.admin.SearchResponse.Aggregation.Value.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admin.SearchResponse.Aggregation.Value} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.SearchResponse.Aggregation.Value.toObject = function(includeInstance, msg) {
  var f, obj = {
    stringAggregation: (f = msg.getStringAggregation()) && proto.admin.SearchResponse.Aggregation.String.toObject(includeInstance, f),
    rangeAggregation: (f = msg.getRangeAggregation()) && proto.admin.SearchResponse.Aggregation.Range.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admin.SearchResponse.Aggregation.Value}
 */
proto.admin.SearchResponse.Aggregation.Value.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admin.SearchResponse.Aggregation.Value;
  return proto.admin.SearchResponse.Aggregation.Value.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admin.SearchResponse.Aggregation.Value} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admin.SearchResponse.Aggregation.Value}
 */
proto.admin.SearchResponse.Aggregation.Value.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.admin.SearchResponse.Aggregation.String;
      reader.readMessage(value,proto.admin.SearchResponse.Aggregation.String.deserializeBinaryFromReader);
      msg.setStringAggregation(value);
      break;
    case 2:
      var value = new proto.admin.SearchResponse.Aggregation.Range;
      reader.readMessage(value,proto.admin.SearchResponse.Aggregation.Range.deserializeBinaryFromReader);
      msg.setRangeAggregation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admin.SearchResponse.Aggregation.Value.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admin.SearchResponse.Aggregation.Value.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admin.SearchResponse.Aggregation.Value} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.SearchResponse.Aggregation.Value.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStringAggregation();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.admin.SearchResponse.Aggregation.String.serializeBinaryToWriter
    );
  }
  f = message.getRangeAggregation();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.admin.SearchResponse.Aggregation.Range.serializeBinaryToWriter
    );
  }
};


/**
 * optional String string_aggregation = 1;
 * @return {?proto.admin.SearchResponse.Aggregation.String}
 */
proto.admin.SearchResponse.Aggregation.Value.prototype.getStringAggregation = function() {
  return /** @type{?proto.admin.SearchResponse.Aggregation.String} */ (
    jspb.Message.getWrapperField(this, proto.admin.SearchResponse.Aggregation.String, 1));
};


/** @param {?proto.admin.SearchResponse.Aggregation.String|undefined} value */
proto.admin.SearchResponse.Aggregation.Value.prototype.setStringAggregation = function(value) {
  jspb.Message.setOneofWrapperField(this, 1, proto.admin.SearchResponse.Aggregation.Value.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 */
proto.admin.SearchResponse.Aggregation.Value.prototype.clearStringAggregation = function() {
  this.setStringAggregation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.admin.SearchResponse.Aggregation.Value.prototype.hasStringAggregation = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Range range_aggregation = 2;
 * @return {?proto.admin.SearchResponse.Aggregation.Range}
 */
proto.admin.SearchResponse.Aggregation.Value.prototype.getRangeAggregation = function() {
  return /** @type{?proto.admin.SearchResponse.Aggregation.Range} */ (
    jspb.Message.getWrapperField(this, proto.admin.SearchResponse.Aggregation.Range, 2));
};


/** @param {?proto.admin.SearchResponse.Aggregation.Range|undefined} value */
proto.admin.SearchResponse.Aggregation.Value.prototype.setRangeAggregation = function(value) {
  jspb.Message.setOneofWrapperField(this, 2, proto.admin.SearchResponse.Aggregation.Value.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 */
proto.admin.SearchResponse.Aggregation.Value.prototype.clearRangeAggregation = function() {
  this.setRangeAggregation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.admin.SearchResponse.Aggregation.Value.prototype.hasRangeAggregation = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string field = 1;
 * @return {string}
 */
proto.admin.SearchResponse.Aggregation.prototype.getField = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.admin.SearchResponse.Aggregation.prototype.setField = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string label = 2;
 * @return {string}
 */
proto.admin.SearchResponse.Aggregation.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.admin.SearchResponse.Aggregation.prototype.setLabel = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated Value aggregations = 3;
 * @return {!Array<!proto.admin.SearchResponse.Aggregation.Value>}
 */
proto.admin.SearchResponse.Aggregation.prototype.getAggregationsList = function() {
  return /** @type{!Array<!proto.admin.SearchResponse.Aggregation.Value>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.admin.SearchResponse.Aggregation.Value, 3));
};


/** @param {!Array<!proto.admin.SearchResponse.Aggregation.Value>} value */
proto.admin.SearchResponse.Aggregation.prototype.setAggregationsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.admin.SearchResponse.Aggregation.Value=} opt_value
 * @param {number=} opt_index
 * @return {!proto.admin.SearchResponse.Aggregation.Value}
 */
proto.admin.SearchResponse.Aggregation.prototype.addAggregations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.admin.SearchResponse.Aggregation.Value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.admin.SearchResponse.Aggregation.prototype.clearAggregationsList = function() {
  this.setAggregationsList([]);
};


/**
 * repeated Hit hits = 1;
 * @return {!Array<!proto.admin.Hit>}
 */
proto.admin.SearchResponse.prototype.getHitsList = function() {
  return /** @type{!Array<!proto.admin.Hit>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.admin.Hit, 1));
};


/** @param {!Array<!proto.admin.Hit>} value */
proto.admin.SearchResponse.prototype.setHitsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.admin.Hit=} opt_value
 * @param {number=} opt_index
 * @return {!proto.admin.Hit}
 */
proto.admin.SearchResponse.prototype.addHits = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.admin.Hit, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.admin.SearchResponse.prototype.clearHitsList = function() {
  this.setHitsList([]);
};


/**
 * repeated Aggregation aggregations = 2;
 * @return {!Array<!proto.admin.SearchResponse.Aggregation>}
 */
proto.admin.SearchResponse.prototype.getAggregationsList = function() {
  return /** @type{!Array<!proto.admin.SearchResponse.Aggregation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.admin.SearchResponse.Aggregation, 2));
};


/** @param {!Array<!proto.admin.SearchResponse.Aggregation>} value */
proto.admin.SearchResponse.prototype.setAggregationsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.admin.SearchResponse.Aggregation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.admin.SearchResponse.Aggregation}
 */
proto.admin.SearchResponse.prototype.addAggregations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.admin.SearchResponse.Aggregation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.admin.SearchResponse.prototype.clearAggregationsList = function() {
  this.setAggregationsList([]);
};


/**
 * optional int32 total = 3;
 * @return {number}
 */
proto.admin.SearchResponse.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.admin.SearchResponse.prototype.setTotal = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string did_you_mean = 4;
 * @return {string}
 */
proto.admin.SearchResponse.prototype.getDidYouMean = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.admin.SearchResponse.prototype.setDidYouMean = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admin.AutocompleteRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.admin.AutocompleteRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admin.AutocompleteRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.AutocompleteRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    query: jspb.Message.getFieldWithDefault(msg, 2, ""),
    limit: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admin.AutocompleteRequest}
 */
proto.admin.AutocompleteRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admin.AutocompleteRequest;
  return proto.admin.AutocompleteRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admin.AutocompleteRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admin.AutocompleteRequest}
 */
proto.admin.AutocompleteRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuery(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admin.AutocompleteRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admin.AutocompleteRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admin.AutocompleteRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.AutocompleteRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQuery();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.admin.AutocompleteRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.admin.AutocompleteRequest.prototype.setId = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string query = 2;
 * @return {string}
 */
proto.admin.AutocompleteRequest.prototype.getQuery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.admin.AutocompleteRequest.prototype.setQuery = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 limit = 3;
 * @return {number}
 */
proto.admin.AutocompleteRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.admin.AutocompleteRequest.prototype.setLimit = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.admin.AutocompleteResponse.repeatedFields_ = [2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admin.AutocompleteResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.admin.AutocompleteResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admin.AutocompleteResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.AutocompleteResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    hitsList: jspb.Message.toObjectList(msg.getHitsList(),
    proto.admin.Hit.toObject, includeInstance),
    completionsList: jspb.Message.getRepeatedField(msg, 3),
    didYouMean: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admin.AutocompleteResponse}
 */
proto.admin.AutocompleteResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admin.AutocompleteResponse;
  return proto.admin.AutocompleteResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admin.AutocompleteResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admin.AutocompleteResponse}
 */
proto.admin.AutocompleteResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.admin.Hit;
      reader.readMessage(value,proto.admin.Hit.deserializeBinaryFromReader);
      msg.addHits(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addCompletions(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDidYouMean(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admin.AutocompleteResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admin.AutocompleteResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admin.AutocompleteResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.AutocompleteResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getHitsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.admin.Hit.serializeBinaryToWriter
    );
  }
  f = message.getCompletionsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getDidYouMean();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.admin.AutocompleteResponse.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.admin.AutocompleteResponse.prototype.setId = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated Hit hits = 2;
 * @return {!Array<!proto.admin.Hit>}
 */
proto.admin.AutocompleteResponse.prototype.getHitsList = function() {
  return /** @type{!Array<!proto.admin.Hit>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.admin.Hit, 2));
};


/** @param {!Array<!proto.admin.Hit>} value */
proto.admin.AutocompleteResponse.prototype.setHitsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.admin.Hit=} opt_value
 * @param {number=} opt_index
 * @return {!proto.admin.Hit}
 */
proto.admin.AutocompleteResponse.prototype.addHits = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.admin.Hit, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.admin.AutocompleteResponse.prototype.clearHitsList = function() {
  this.setHitsList([]);
};


/**
 * repeated string completions = 3;
 * @return {!Array<string>}
 */
proto.admin.AutocompleteResponse.prototype.getCompletionsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/** @param {!Array<string>} value */
proto.admin.AutocompleteResponse.prototype.setCompletionsList = function(value) {
  jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.admin.AutocompleteResponse.prototype.addCompletions = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.admin.AutocompleteResponse.prototype.clearCompletionsList = function() {
  this.setCompletionsList([]);
};


/**
 * optional string did_you_mean = 4;
 * @return {string}
 */
proto.admin.AutocompleteResponse.prototype.getDidYouMean = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.admin.AutocompleteResponse.prototype.setDidYouMean = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


goog.object.extend(exports, proto.admin);
